import { render } from "./Vnud-adicionar.vue?vue&type=template&id=4b0f65ad"
import script from "./Vnud-adicionar.vue?vue&type=script&lang=js"
export * from "./Vnud-adicionar.vue?vue&type=script&lang=js"

import "./Vnud-adicionar.vue?vue&type=style&index=0&id=4b0f65ad&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__